<div class="close-button-row d-flex justify-content-between align-items-center">
  <div class="form-header">
    <span>{{ title }}</span>
  </div>
  <a *ngIf="showClose" role="button" class="close-icon button-icon" (click)="goBack()">
    <i class="material-icons close-icon">close</i>
  </a>
</div>
